export default "__VITE_ASSET__7c870525__"